export const pieGraphColors = ['#fa824c', '#DD7476', '#DA5ABA', '#A558C6', '#9522DF', '#3C22DF', '#2E65F2', '#3FB4F6'];

export const usdFormatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
